var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamChatHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9979 2.84576H12.5365C11.1754 2.84224 9.83031 3.16081 8.61328 3.77554C5.64677 5.25814 3.77004 8.29285 3.76875 11.6131L3.77456 11.9531C3.81202 12.9715 4.02946 13.9755 4.41593 14.918L4.52923 15.1796L2.8932 20.0894L2.86606 20.1874C2.71517 20.8713 3.3719 21.4863 4.0606 21.2568L8.96939 19.6198L9.23196 19.734C10.2792 20.1634 11.4026 20.3842 12.5389 20.3812C15.8571 20.3799 18.8918 18.5032 20.3762 15.5332C20.9891 14.3196 21.3077 12.9746 21.3042 11.6111L21.3042 11.152C21.0617 6.73176 17.6321 3.22486 13.2952 2.8642L12.9979 2.84576ZM12.5341 4.69159L12.9592 4.6907L12.9471 4.69019C16.4605 4.88405 19.2659 7.68945 19.4598 11.2029L19.4584 11.6135C19.4611 12.6887 19.2105 13.7469 18.7268 14.7045C17.5532 17.0527 15.1574 18.5344 12.5361 18.5354C11.4613 18.5382 10.403 18.2875 9.44548 17.8039L9.33298 17.7561C9.14147 17.6894 8.93206 17.6873 8.73752 17.7521L5.22696 18.9221L6.39785 15.4124C6.47566 15.179 6.45703 14.9241 6.34609 14.7045C5.86242 13.7469 5.61178 12.6887 5.61458 11.6159C5.6156 8.99257 7.09723 6.59675 9.44197 5.42488C10.403 4.93946 11.4613 4.68882 12.5341 4.69159Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamChatHeaderIcon);
export default __webpack_public_path__ + "static/media/team_chat_header_icon.8844c585bf448f9a9d1189cc4da561c0.svg";
export { ForwardRef as ReactComponent };